<template>
    <div class="ml-4">
        <h1 class="text-muted mb-4">
            <vue-fontawesome class="mr-2" icon="building"></vue-fontawesome>
            Business details
        </h1>

        <section>    
            <div class="d-flex justify-content-between">
                <div>
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" 
                                id="pills-home-tab" 
                                data-toggle="pill" 
                                href="#pills-home" 
                                role="tab" 
                                aria-controls="pills-home" 
                                aria-selected="true">
                                                        
                                Business details
                            </a>
                        </li>                               							
                    </ul>
                </div>                   
            </div>	            
            <div class="tab-pane fade show active" 
                id="pills-home" 
                role="tabpanel"                 
                aria-labelledby="pills-home-tab">                                
                <div class="col-lg-6" v-if="details">
                    <form id="updateBusinessDetailForm">
                        <div class="form-group">
                            <label class="font-weight-bold">Name</label>
                            <input type="text" class="form-control" v-model="details.name" required/>
                        </div>
                        <div class="form-group">
                            <label class="font-weight-bold">Email</label>
                            <input type="text" class="form-control" v-model="details.email"/>
                        </div>
                        <div class="form-group">
                            <label class="font-weight-bold">Phone</label>
                            <input type="text" class="form-control" v-model="details.phone" required/>
                        </div>
                        <div class="form-group">
                            <label class="font-weight-bold">PO Box</label>
                            <input type="text" class="form-control" v-model="details.po_box"/>
                        </div>
                        <div class="form-group">
                            <label class="font-weight-bold">Address</label>
                            <input type="text" class="form-control" v-model="details.address"/>
                        </div>
                        <div class="form-group">
                            <label class="font-weight-bold">Motto</label>
                            <input type="text" class="form-control" v-model="details.motto"/>
                        </div>
                        <div class="form-group">
                            <label class="font-weight-bold">V.A.T number</label>
                            <input type="text" class="form-control" v-model="details.vat_number"/>
                        </div>
                        <div class="d-flex justify-content-end">
                            <button class="btn btn-success">Update</button>
                        </div>
                    </form>
                </div> 
                <div v-else class="d-flex justify-content-center">
                    <div class="spinner-border m-5" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>  
                </div>                             
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        name: 'businessDetails',    
        data(){
            return{
                details:null,                
            }
        },
        mounted(){
            this.getDetails()            
        },
        methods:{		
            //get business details.
            getDetails: function(){            
                this.$http({
                    method:'get',				
                    url: this.$API_BASE_URL + `/HJYBCFRB/business-details/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },                
                }).then((response)=>{
                    this.details = response.data
                }).catch((err)=>{
                    this.$emit('alert',err)
                })
            },
            //update details.
            updateDetails: function(){
                this.$http({
                    method:'post',				
                    url: this.$API_BASE_URL + `/HJYBCFRB/business-details/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },                
                }).then((response)=>{
                    this.details = response.data
                }).catch((err)=>{
                    this.$emit('alert',err)
                })
            }

        }
    }
</script>
      